export default "__VITE_ASSET__ByTElFC9__"